import React from 'react'

export default function Header() {
  return (
    <h1 style={{textAlign: "center"}}>Cloudflare Workers Dashboard</h1>
  )
}
